var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 23,
    viewBox: "0 0 44 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.652832,
    width: 44,
    height: 22,
    rx: 10,
    fill: "url(#paint0_linear_3320_2421)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32969 15.6528V7.16846H12.4352C14.2398 7.16846 15.1187 8.14111 15.1187 9.39502C15.1187 10.4497 14.4742 10.9888 13.6891 11.188V11.27C14.5328 11.3169 15.4469 12.0552 15.4469 13.3677C15.4469 14.6685 14.5562 15.6528 12.5758 15.6528H9.32969ZM12.4586 14.5513C13.6773 14.5513 14.1695 14.0122 14.1695 13.3091C14.1695 12.5005 13.525 11.8442 12.5055 11.8442H10.6187V14.5513H12.4586ZM12.3297 10.8364C13.1852 10.8364 13.8531 10.3091 13.8531 9.50049C13.8531 8.79736 13.3727 8.27002 12.3531 8.27002H10.6187V10.8364H12.3297ZM16.2297 15.6528V7.16846H21.55V8.28174H17.5187V10.8481H21.2687V11.9497H17.5187V14.5396H21.5969V15.6528H16.2297ZM22.1102 8.28174V7.16846H28.6844V8.28174H26.0477V15.6528H24.7586V8.28174H22.1102ZM29.1039 15.6528H27.7328L30.7797 7.16846H32.268L35.3266 15.6528H33.9555L33.182 13.4146H29.8773L29.1039 15.6528ZM30.2523 12.3364H32.807L31.5531 8.71533H31.4945L30.2523 12.3364Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3320_2421",
    x1: 0,
    y1: 11.6528,
    x2: 44,
    y2: 11.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9819C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.0fec40966623ec33c8ec01dfaf685ff7.svg";
export { ForwardRef as ReactComponent };